<!-- eslint-disable -->
<template lang="pug">
    .progress-map-wrapper(v-if="user.mapLocation.id !== 69 && user.type === 'student'")
        template(v-if="isButtonLoading")
            div
                template(v-if="user.miles < user.mapLocation.requiredMiles")
                    | {{ $i18n.t('map.map_progress_to') }}
                    | {{ $i18n.t('mapModal.cases.genitive')[user.mapLocation.nextCity] }}
                span.next-city-button(v-else @click="updateCity()")
                    | {{ $i18n.t('map.map_progress_enough') }}
                    | {{ $i18n.t('mapModal.locationsWithPretext')[user.mapLocation.nextCity] }}
            progress.progress.is-info(
                    :class="{ 'animate': isAllowedToAnimate, 'next-city-button': user.miles >= user.mapLocation.requiredMiles}"
                    :value="user.miles"
                    :max="user.mapLocation.requiredMiles"
                    @click="user.miles >= user.mapLocation.requiredMiles && updateCity()"
            )
            span.progress-text(v-if="user.miles < user.mapLocation.requiredMiles")
                | {{ user.miles }} {{ $i18n.t('map.map_progress_of') }} {{ user.mapLocation.requiredMiles }}
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import UserApi from "../../../api/user/user";
    import continents from '../../../config/continents'
    import continentsWithTransition from './config/continentsWithTransition'

    export default {
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            isAllowedToAnimate () {
                return this.user.miles >= this.user.mapLocation.requiredMiles;
            }
        },
        data () {
            return {
                isButtonLoading: false
            }
        },
        watch: {
            '$root.isNextCityDisabled': {
                handler (value) {
                    this.isButtonLoading = value;
                },
                immediate: true
            },
            '$route.name': {
                handler () {
                    this.isButtonLoading = false;
                },
                immediate: true
            }
        },
        methods: {
            updateCity () {
                let mapLocation = this.user.mapLocation;
                let nextContinent = continents[mapLocation.nextCity];
                if (continents[mapLocation.name] !== nextContinent && continentsWithTransition.includes(nextContinent)) {
                    this.$root.continentTransition = true;
                    return;
                }
                this.isButtonLoading = true;
                if (this.user.mapLocation.nextCity) {
                    UserApi.updateCity(this.user.id)
                        .then(() => {
                            let newContinent = continents[this.user.mapLocation.nextCity];
                            if (newContinent !== continents[this.user.mapLocation.name]) {
                                this.$emit('changeContinent', newContinent);
                            }
                            this.$store.dispatch('setUserByToken');
                        })
                        .catch(error => {
                            this.$toasted.error(this.$root.$t(`errors.${error.data.message}`));
                        })
                }
            }
        }
    }
</script>

<style lang="scss">
    .progress-map-wrapper {
        @media all and (orientation: portrait) {
            display: none;
        }
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding-top: 12px;
        padding-bottom: 12px;
    }

    .next-city-button {
        cursor: pointer;
    }

    .progress {
        margin: 3px 0 0;
        width: 20rem;
        height: 1.2rem;
        border-radius: 5px;
        color: $x-color-orange;
        background-color: $hsl-color-green-58;
        @media screen and (max-width: 1000px) {
            width: 15rem;
        }
        &::-webkit-progress-value {
                   background: $x-color-orange;
        }

        &::-moz-progress-bar {
           background: $x-color-orange;
        }

        &::-webkit-progress-bar {
           background-color: $hsl-color-green-58;
        }
    }

    .is-info {
        color: $hsl-color-green-58;
    }

    .progress-text {
        margin: 2px 0 0;
        position: absolute;
        top: 42px;
        right: 20px;
        left: 20px;
        color: $x-color-white;
        font-size: 0.9rem;
        font-weight: 500;
        @media screen and (max-width: 768px) {
            font-size: 0.75rem;
        }
    }

    .animate {
        @keyframes animate-progress-scale {
            0% {transform: scale(1, 1)}
            50% {transform: scale(1.05, 1)}
            100% {transform: scale(1, 1)}
        }
        animation: animate-progress-scale 1s ease 0s infinite;
    }

    .sk-circle {
        margin: 0;
        height: 1.2rem;
        width: 1.2rem;
    }
</style>
